export const OVERLAY_CONTAINER_ID = 'OverlayContainer';
export const MODULE_CONTAINER_ID = 'ModuleContainer';
export const MAIN_NAVIGATION_ID = 'MainNavigation';
export const OVERLAY_CONTAINER_SELECTOR = `#${OVERLAY_CONTAINER_ID}`;
export const MAIN_NAVIGATION_SELECTOR = `#${MAIN_NAVIGATION_ID}`;
